import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useGlobalContext } from '@/context/global.context';
import { SolicitudProvider } from '@/context/solicitud.context';
import { TramiteProvider } from '@/context/tramite.context';
import { useSyncOptions } from '@/hooks/useOptions';
import TramiteDocumentacionDetalle from '@/pages/TramiteDocumentacionDetalle';
import TramiteHome from '@/pages/TramiteHome';
import TramiteNuevo from '@/pages/TramiteNuevo';
import TramiteSolicitudDetalle from '@/pages/TramiteSolicitudDetalle';
import Documentacion from '@/pages/TramiteSolicitudDocumentacion';
import TramiteSolicitudDocumentacionDetalle from '@/pages/TramiteSolicitudDocumentacionDetalle';
import TramiteSolicitudesBorradores from '@/pages/TramiteSolicitudesBorradores';
import TramiteSubsanaciones from '@/pages/TramiteSubsanaciones';
import TramiteSubsanacionesDetalle from '@/pages/TramiteSubsanacionesDetalle';
import TramiteSuccess from '@/pages/TramiteSuccess/intex';
import TramiteSujetoDetalle from '@/pages/TramiteSujetoDetalle';

import { ROUTES_TRAMITE_RELATIVE } from '@/constants/routes.constants';

const RoutesTramite = ({ tipoTramiteId }: { readonly tipoTramiteId: number }) => {
	const { loadmaestrosTramite, setTramiteSeleccionado, tramiteSeleccionado, cleanMaestroTramite } =
		useGlobalContext();
	const isCurrentTramite = tramiteSeleccionado === tipoTramiteId;
	useSyncOptions(tipoTramiteId);

	useEffect(() => {
		if (isCurrentTramite) {
			loadmaestrosTramite(tipoTramiteId);
		} else {
			cleanMaestroTramite();
			setTramiteSeleccionado(tipoTramiteId);
		}
	}, [isCurrentTramite]);

	if (!isCurrentTramite) return <></>;

	return (
		<Routes>
			<Route index element={<TramiteHome />} />
			<Route element={<SolicitudProvider />}>
				<Route path={ROUTES_TRAMITE_RELATIVE.BORRADORES_NEW} element={<TramiteNuevo />} />
				<Route path={`${ROUTES_TRAMITE_RELATIVE.BORRADORES}/:id`} element={<TramiteNuevo />} />
			</Route>
			<Route path={ROUTES_TRAMITE_RELATIVE.SOLICITUDES} element={<TramiteSolicitudesBorradores />} />
			<Route path={ROUTES_TRAMITE_RELATIVE.TRAMITE_SUCCESS} element={<TramiteSuccess />} />
			<Route path={ROUTES_TRAMITE_RELATIVE.SUBSANACIONES_ATENDIDAS} element={<TramiteSubsanaciones />} />
			<Route path={ROUTES_TRAMITE_RELATIVE.SUBSANACIONES_PENDIENTES} element={<TramiteSubsanaciones />} />
			<Route path={ROUTES_TRAMITE_RELATIVE.SOLICITUDES_DOCUMENTACION_ATENDIDAS} element={<Documentacion />} />
			<Route path={ROUTES_TRAMITE_RELATIVE.SOLICITUDES_DOCUMENTACION_PENDIENTES} element={<Documentacion />} />
			<Route path={ROUTES_TRAMITE_RELATIVE.BORRADORES} element={<TramiteSolicitudesBorradores />} />
			<Route
				path={ROUTES_TRAMITE_RELATIVE.SOLICITUDES_DOCUMENTACION}
				element={<Documentacion />}
			/>
			<Route
				path={`${ROUTES_TRAMITE_RELATIVE.SOLICITUDES_DOCUMENTACION_DETALLE}/:idTramite/:idTipoSubsanacion/:idSubsanacion`}
				element={<TramiteSolicitudDocumentacionDetalle />}
			/>
			<Route element={<TramiteProvider />}>
				<Route
					path={`${ROUTES_TRAMITE_RELATIVE.SOLICITUDES}/:idTramite`}
					element={<TramiteSolicitudDetalle />}
				/>
				<Route path={ROUTES_TRAMITE_RELATIVE.DETALLE_DOCUMENTO} element={<TramiteDocumentacionDetalle />} />
				<Route
					path={ROUTES_TRAMITE_RELATIVE.DETALLE_DOCUMENTO_SUBSANABLE}
					element={<TramiteDocumentacionDetalle />}
				/>
				<Route path={ROUTES_TRAMITE_RELATIVE.DETALLE_SUJETO} element={<TramiteSujetoDetalle />} />
				<Route path={ROUTES_TRAMITE_RELATIVE.DETALLE_SUJETO_SUBSANABLE} element={<TramiteSujetoDetalle />} />
			</Route>
			<Route path={ROUTES_TRAMITE_RELATIVE.SUBSANACIONES} element={<TramiteSubsanaciones />} />
			<Route path={ROUTES_TRAMITE_RELATIVE.SUBSANACIONES_DETALLE} element={<TramiteSubsanacionesDetalle />} />
		</Routes>
	);
};

export default RoutesTramite;
